import { format, getTime, formatDistanceToNow } from 'date-fns';

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
      addSuffix: true,
    })
    : '';
}

export function fToNowAmh(date) {
  const now = new Date().getTime() / 1000;
  const dateInSeconds = new Date(date).getTime() / 1000;

  const dateDifference = now - dateInSeconds; 

  const secondsInYear = 60 * 60 * 24 * 365;
  const secondsInMonth = 60 * 60 * 24 * 30;
  const secondsInDay = 60 * 60 * 24;
  const secondsInHour = 60 * 60;
  const secondsInMinute = 60;

  let toNow;

  if (dateDifference > secondsInYear) {
    const years = Math.floor(dateDifference / secondsInYear);
    toNow = `[ከ ${years} ዓመት በፊት]`;
  } else if (dateDifference > secondsInMonth) {
    const months = Math.floor(dateDifference / secondsInMonth);
    toNow = `[ከ ${months} ወር በፊት]`;
  } else if (dateDifference > secondsInDay) {
    const days = Math.floor(dateDifference / secondsInDay);
    toNow = `[ከ ${days} ቀን በፊት]`;
  } else if (dateDifference > secondsInHour) {
    const hours = Math.floor(dateDifference / secondsInHour);
    toNow = `[ከ ${hours} ሰዓት በፊት]`;
  } else if (dateDifference > secondsInMinute) {
    const minutes = Math.floor(dateDifference / secondsInMinute);
    toNow = `[ከ ${minutes} ደቂቃ በፊት]`;
  } else {
    toNow = `[አሁን]`;
  }

  return toNow;
}
